import { render, staticRenderFns } from "./RequestNewVerification.vue?vue&type=template&id=03cff9b8&scoped=true&"
import script from "./RequestNewVerification.vue?vue&type=script&lang=js&"
export * from "./RequestNewVerification.vue?vue&type=script&lang=js&"
import style0 from "./RequestNewVerification.vue?vue&type=style&index=0&id=03cff9b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cff9b8",
  null
  
)

export default component.exports